/**
 * Save / open actions of a research finding: *Uložiť ako vyšetrovanie* before the
 * finding is saved, *Zobraziť vyšetrovanie* after. Shared by the entity finding card
 * and the source-only one (PRD-0076 SC-017).
 */

import { ArrowRight, Bookmark, Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { investigationPath } from '@/features/analytic-hypotheses/paths'

/** Saving a finding: in flight, and the call that starts it. */
export interface FindingPromotion {
  isPending: boolean
  onPromote: () => void
}

interface FindingActionProps {
  caseId: string
  /** The investigation the finding was saved to; null while it is not saved. */
  investigationId: string | null
  promotion: FindingPromotion
}

export function PromoteHint({ caseId, investigationId, promotion }: FindingActionProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  if (investigationId) {
    return (
      <Button
        type="button"
        variant="ghost"
        size="xs"
        className="gap-1.5 text-primary max-md:h-9"
        onClick={() => navigate(investigationPath(caseId, investigationId))}
      >
        {t('search.detail.finding.showInvestigationDetail')}
        <ArrowRight className="size-3.5" />
      </Button>
    )
  }
  return (
    <Button
      type="button"
      variant="outline"
      size="xs"
      className="gap-1.5 max-md:h-9"
      disabled={promotion.isPending}
      onClick={promotion.onPromote}
    >
      {promotion.isPending ? (
        <Loader2 className="size-3.5 animate-spin" />
      ) : (
        <Bookmark className="size-3.5" />
      )}
      {t('search.detail.finding.saveAsInvestigation')}
    </Button>
  )
}

export function FindingActions(props: FindingActionProps) {
  return (
    <div className="mt-1 flex flex-wrap items-center gap-2 border-t border-border/40 pt-2">
      <PromoteHint {...props} />
    </div>
  )
}
